class MCartDrawer extends HTMLElement {
    constructor() {

        super(), this.cartDrawerInner = this.querySelector(".m-cart-drawer__bsf-inner"), this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close"), this.cartOverlay = this.querySelector(".m-cart__overlay"), this.rootUrl = window.Shopify.routes.root, this.setHeaderCartIconAccessibility(), this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));

        this.addEventListener("click", (e => {
            e.target.closest(".m-cart-drawer__bsf-inner") !== this.cartDrawerInner && this.close()
        }))
    }

    setHeaderCartIconAccessibility() {
        document.querySelectorAll(".m-cart-icon-bubble").forEach((e => {
            e.setAttribute("role", "button"), e.setAttribute("aria-haspopup", "dialog"), e.addEventListener("click", (t => {
                MinimogSettings.enable_cart_drawer && (t.preventDefault(), this.open(e))
            }))
        }))
    }

    open(e) {
        e && this.setActiveElement(e), this.classList.add("m-cart-drawer--active"), requestAnimationFrame((() => {
            this.style.setProperty("--m-bg-opacity", "0.5"), this.cartDrawerInner.style.setProperty("--translate-x", "0")
            const bodyOverlay = document.querySelector('.body-overlay');
            if (bodyOverlay) {
                bodyOverlay.style.setProperty("--m-bg-opacity", "0.5");
            }
        })), window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer), document.documentElement.classList.add("prevent-scroll"),
        this.renderBundleInfo()
    }

    close() {
        this.style.setProperty("--m-bg-opacity", "0"), this.cartDrawerInner.style.setProperty("--translate-x", "210%")
        const bodyOverlay = document.querySelector('.body-overlay');
        if (bodyOverlay) {
            bodyOverlay.style.setProperty("--m-bg-opacity", "0");
        }
        setTimeout((() => {
            this.classList.remove("m-cart-drawer--active"), document.documentElement.classList.remove("prevent-scroll")
        }), 300)
    }

    renderContents(e, fromRecommendation = false) {
        this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty"), this.productId = e.id, this.getSectionsToRender().forEach((t => {
            (t.selector ? document.querySelector(t.selector) : document.getElementById(t.id)).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector)
        }));
        if (!fromRecommendation) {
            setTimeout((() => {
                this.open()
            }));
        } else {
            setTimeout((() => {
                this.renderBundleInfo()
            }));
        }
    }

    updateCartCount(e) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((t => {
            e > 0 ? (t.textContent = e, t.classList.remove("m:hidden")) : t.classList.add("m:hidden")
        }))
    }

    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }

    onCartDrawerUpdate(e = !0) {
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`).then((e => e.text())).then((t => {
            this.getSectionsToRender().forEach((r => {
                if ("cart-items" === r.block) {
                    (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(t, r.selector)
                } else if (e) {
                    (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(t, r.selector)
                }
            }))
        })).catch((e => {
        })), this.getCart().then((e => {
            this.classList.toggle("m-cart--empty", 0 === e.item_count), this.updateCartCount(e.item_count)
        }))
    }

    getSectionInnerHTML(e, t = ".shopify-section") {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
    }

    getSectionsToRender() {
        return [{id: "cart-drawer", selector: "[data-minimog-cart-items]", block: "cart-items"}, {
            id: "cart-drawer",
            selector: "[data-minimog-cart-discounts]",
            block: "cart-footer"
        }, {id: "cart-drawer", selector: "[data-cart-subtotal]", block: "cart-footer"}, {
            id: "cart-drawer",
            selector: "[data-minimog-gift-wrapping]",
            block: "cart-footer"
        }]
    }

    getSectionDOM(e, t = ".shopify-section") {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t)
    }

    setActiveElement(e) {
        this.activeElement = e
    }

    renderBundleInfo() {
        document.querySelectorAll('.m-cart-drawer-item').forEach((t => {
            var original_price =parseInt(t.dataset.productOriginalPrice);
            var discount_application = parseInt(t.dataset.productDiscount);
            var product_type = t.dataset.productType;
            var product_antal = parseInt(t.dataset.productAntal);
            var suffix_unit = 'stk.';
            var qty_label_suffix = 'stk.';
            var is_divide_by_antal = false;
            var label = '';
            var quantity_label = '';

            for (var i = 0; i < bundle_constant.length; i++) {
                if (bundle_constant[i].product_type == product_type) {
                  suffix_unit = bundle_constant[i].suffix_unit;
                  qty_label_suffix = bundle_constant[i].qty_label_suffix;
                  if ((product_antal > 1) && bundle_constant[i].qty_label_suffix_plural) {
                    qty_label_suffix = bundle_constant[i].qty_label_suffix_plural;
                  }
                  if (bundle_constant[i].calc_rule == 'antal') {
                    is_divide_by_antal = true;
                  }
                }
            }

            if (product_antal > 0) {
                if (is_divide_by_antal) {
                    var bundle_price = original_price / product_antal;
                    if (discount_application > 0) {
                        var discount_amount = original_price * discount_application * 0.01;
                        bundle_price = (original_price - discount_amount) / product_antal;
                    }
                } else {
                    var bundle_price = original_price;
                    if (discount_application > 0) {
                        var discount_amount = original_price * discount_application * 0.01;
                        bundle_price = (original_price - discount_amount);
                    }
                }
                label = formatMoney(bundle_price, window.MinimogSettings.money_format) + ' pr. ' + suffix_unit;
                quantity_label = product_antal + ' ' + qty_label_suffix;
            } else {
                label = formatMoney(original_price, window.MinimogSettings.money_format) + ' pr. ' + suffix_unit;
            }
            t.querySelector('.m-cart-item__price_per_unit').innerHTML = label;
            if (t.querySelector('.m-cart-item__quantity-label')) {
                t.querySelector('.m-cart-item__quantity-label').innerHTML = quantity_label;
            }
        }))
    }

}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
    getSectionsToRender() {
        return [{
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-items]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-discounts]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-cart-subtotal]"
        }, {id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-gift-wrapping]"}]
    }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);